module.exports = __webpack_public_path__ + "media/images/svg/up-arrow-137dd3099e5d1ad89d15371d1c10ab54.svg";